import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MailInfo } from './../../../model/mail-info.model';
import { RejectReason } from '../../../model/mail-reject-reasons';
import { SearchCondition } from 'src/app/shared/model/search-condition.model';
import { PageEnums } from 'src/app/shared/enum/page-enums';
@Component({
  selector: 'app-card-detail-info',
  templateUrl: './card-detail-info.component.html',
  styleUrls: ['./card-detail-info.component.scss']
})
export class CardDetailInfoComponent implements OnInit {
  @Input() mailInfo: MailInfo;
  @Input() pairMail: MailInfo;
  @Input() workerMail: MailInfo;
  @Input() projectMail: MailInfo;
  @Input() baseMailType: string;
  @Input() rejectReason: RejectReason;
  @Input() searchParams: SearchCondition;
  @Input() page: string; // 存在するページ
  isAutoPage = false;
  isOfferPage = false;

  @Input() baseKeywords: Array<String> = [];

  constructor() {}

  ngOnInit() {
    this.isAutoPage = this.page === PageEnums.auto;
    this.isOfferPage = this.page === PageEnums.offer;
  }

  // 重要行以外を表示するかどうかの切り替え
  changeShowOnlyImportantLine(mailInfo) {
    mailInfo.showOtherThanImportantLine = !mailInfo.showOtherThanImportantLine;
  }
}
